import { integrationsActions } from '../../_actions/integrations.actions';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { IntegrationApp } from '../../_models/IntegrationApp';
import { CustomCard } from '../../_components';
import { integrationLogoForCompany } from '../../_assets/integrationsLogo';

type SingleDeviceProps = {
    integration: any,
    selectedIntegrationId?: string,
    status: any,
    onSelect?: (company: string) => void,
}

export function SingleIntegration({
    integration = IntegrationApp(),
    selectedIntegrationId,
    status,
    onSelect,
}: SingleDeviceProps) {

    //LIBRARIES
    const dispatch = useDispatch();
    const isSelected = useMemo(
        () => selectedIntegrationId === integration.id,
        [selectedIntegrationId, integration.id],
    );
   
    //VIEW
    return (
        <CustomCard
            onClick={() => {
                openIntegrationDetails();
            }}
            className="cp"
            selected={isSelected}
            banner={showStatus()}
        >
            <div
                data-testid="single-integration"
                data-company={integration.company}
                className={`
                d-flex
                no-gutters
                align-items-center
                justify-content-center
            `}
            >
                {logo()}
            </div>
        </CustomCard>
    );


    function logo() {
        return (
            <img
            className="c-img w-100"
            style={{ maxWidth: "180px" }}
            src={integrationLogoForCompany(integration.company)}
            alt="device type icon"
            />
        );
    }

    function showStatus() {
        if (status == null) 
            return null;

        return (
            <div
                className="
                    text-right
                    c-line-height-1rem
                "
            >
                { status }
            </div>
        );
    }

    //ACTION HANDLERS
    function openIntegrationDetails() {
        onSelect?.(integration.company);
        return dispatch(integrationsActions.changeSecondaryView(integration.company));
    }
}